import { render, staticRenderFns } from "./AddReseller.vue?vue&type=template&id=bc2071a8"
import script from "./AddReseller.vue?vue&type=script&lang=js"
export * from "./AddReseller.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports